import { useCallback, useRef, useState } from 'react'

const DEFAULT_ZOOM = 1
const ZOOM_STEP = 0.1

export const useZoom = () => {
  const zoomRef = useRef<HTMLDivElement>(null)
  const [currentZoomLevel, setCurrentZoomLevel] = useState(DEFAULT_ZOOM)

  const zoomIn = useCallback(() => {
    const element = zoomRef.current
    if (!element) return
    setCurrentZoomLevel((current) => {
      const next = current + ZOOM_STEP
      element.style.transform = `scale(${next})`
      return next
    })
  }, [])

  const zoomOut = useCallback(() => {
    const element = zoomRef.current
    if (!element) return
    setCurrentZoomLevel((current) => {
      const next = current - ZOOM_STEP
      element.style.transform = `scale(${next})`
      return next
    })
  }, [])

  const resetZoom = useCallback(() => {
    if (zoomRef.current) {
      setCurrentZoomLevel(DEFAULT_ZOOM)
      zoomRef.current.style.transform = `scale(${DEFAULT_ZOOM})`
    }
  }, [])

  return {
    zoomRef,
    zoomIn,
    zoomOut,
    resetZoom,
    currentZoomLevel,
  }
}
